import { render, staticRenderFns } from "./CurrencySelection.vue?vue&type=template&id=01afd28f&"
import script from "./CurrencySelection.vue?vue&type=script&lang=js&"
export * from "./CurrencySelection.vue?vue&type=script&lang=js&"
import style0 from "./CurrencySelection.vue?vue&type=style&index=0&id=01afd28f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports